import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./alert-dialog"
import { Button } from "./button"
import { useStore } from '@/store/useStore';
import { X } from 'lucide-react';

interface AlertProps {
  open: boolean;
  setOpen: () => void;
  onClick: (actionId: number) => void;
}

const NewPlanAlert = ({ open, setOpen, onClick }: AlertProps) => {

  const handleAction = (actionId: 0 | 1 | 2) => {
    onClick(actionId);
  }
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        {/* Close (X) button */}
        <button
          onClick={() => setOpen()}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>
        <AlertDialogHeader>
          <AlertDialogTitle>Meal Planning Options</AlertDialogTitle>
          <AlertDialogDescription>
            Would you like to save this as a reusable meal plan template or generate a full 4-week plan now?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className='bg-purple' onClick={() => handleAction(2)}>Save Template</AlertDialogCancel>
          <AlertDialogAction className='bg-info' onClick={() => handleAction(1)}>Create Plan</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default NewPlanAlert;